import { Component, ComponentChildren } from 'preact'
// Too much files to replace
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
import classnames from 'classnames'

interface ConfigurationSectionLabelProps {
  title: string
  children: ComponentChildren
  isExtended?: boolean
  templateSection?: boolean
}

interface State {
  isExtended: boolean
}

export default class ConfigurationSectionLabel extends Component<ConfigurationSectionLabelProps, State> {
  constructor (props: ConfigurationSectionLabelProps) {
    super(props)

    this.state = {
      isExtended: props.isExtended ?? true
    }
  }

  render() {
    const { title, children, templateSection = false } = this.props
    const { isExtended } = this.state
    const classes = classnames('widget-configurator_tab', templateSection ? 'homepage-widget-configurator_tab-template' : 'homepage-widget-configurator_tab-content')

    return (
      <div className={classes}>
        <div className='widget-configurator_tab-header' onClick={() => this.setState({ isExtended: !isExtended })}>
          <div className='widget-configurator_tab-icon'>
            <Icon size={24} color='#2B3346' icon={isExtended ? 'chevronDown' : 'chevronRight'} />
          </div>
          {title}
        </div>
        {
          isExtended && (
            <div className='widget-configurator_tab-content'>
              {children}
            </div>)
        }
      </div>
    )
  }
}
